import React from 'react';
import { Grid } from '@mui/material';
import { Tooltip } from '@mui/material';
import ToolBreadcrumb from 'components/Common/ToolBreadcrumb';

interface IHeaderLayoutProps {
  children?: React.ReactNode;
  title: string;
  helpContent?: any;
  isWhiteLabel?: boolean;
  // When set, renders a "🏠 hubLabel > title" breadcrumb above the page
  // title for pages only reached by drilling into another tool (e.g. a
  // Data Catalog card), matching the Import Hub pattern.
  hubLabel?: string;
  hubTo?: string;
}

const ModuleHeaderLayout: React.FC<IHeaderLayoutProps> = (
  props: IHeaderLayoutProps,
) => {
  const { children, title, helpContent, isWhiteLabel, hubLabel, hubTo } =
    props;

  return (
    <section
      className='home-content-body Home-HeaderDown'
      style={{ minHeight: 0 }}
    >
      <Grid container>
        {!isWhiteLabel && (
          <Grid item xs={12}>
            <div className='module-header'>
              {hubLabel && (
                <ToolBreadcrumb
                  items={[{ label: hubLabel, to: hubTo }, { label: title }]}
                />
              )}
              <div className='module-header-breadcrumbs'>
                <h1 className='analyzers-page-title'>{title}</h1>
                <div className='module-header-title-conts'>
                  {/* <h1>
                  {
                    title.includes('Ask') && (
                      <Tooltip
                        title={'AI Assistant that will help answer your compliance questions'}
                        placement='bottom-start'
                        arrow
                        componentsProps={{
                          tooltip: {
                            sx: {
                              'display': 'flex',
                              'padding': 'var(--spacing-md, 8px) var(--spacing-lg, 12px)',
                              'flexDirection': 'column',
                              'alignItems': 'flex-start',
                              'alignSelf': 'stretch',
                              'borderRadius': 'var(--radius-md, 8px)',
                              'background': 'var(--Background-200, var(--bg-colors))',
                              'maxWidth': '700px',
                              '& .MuiTooltip-arrow': {
                                color: 'var(--Background-200, var(--bg-colors))'
                              }
                            },
                          },
                        }}
                      >
                        <svg fill='#4895EF' width='18' height='18' style={{ marginRight: '10px', marginBottom: '5px' }} viewBox='0 0 512 512' id='icons' xmlns='http://www.w3.org/2000/svg'><path d='M208,512a24.84,24.84,0,0,1-23.34-16l-39.84-103.6a16.06,16.06,0,0,0-9.19-9.19L32,343.34a25,25,0,0,1,0-46.68l103.6-39.84a16.06,16.06,0,0,0,9.19-9.19L184.66,144a25,25,0,0,1,46.68,0l39.84,103.6a16.06,16.06,0,0,0,9.19,9.19l103,39.63A25.49,25.49,0,0,1,400,320.52a24.82,24.82,0,0,1-16,22.82l-103.6,39.84a16.06,16.06,0,0,0-9.19,9.19L231.34,496A24.84,24.84,0,0,1,208,512Zm66.85-254.84h0Z'/><path d='M88,176a14.67,14.67,0,0,1-13.69-9.4L57.45,122.76a7.28,7.28,0,0,0-4.21-4.21L9.4,101.69a14.67,14.67,0,0,1,0-27.38L53.24,57.45a7.31,7.31,0,0,0,4.21-4.21L74.16,9.79A15,15,0,0,1,86.23.11,14.67,14.67,0,0,1,101.69,9.4l16.86,43.84a7.31,7.31,0,0,0,4.21,4.21L166.6,74.31a14.67,14.67,0,0,1,0,27.38l-43.84,16.86a7.28,7.28,0,0,0-4.21,4.21L101.69,166.6A14.67,14.67,0,0,1,88,176Z'/><path d='M400,256a16,16,0,0,1-14.93-10.26l-22.84-59.37a8,8,0,0,0-4.6-4.6l-59.37-22.84a16,16,0,0,1,0-29.86l59.37-22.84a8,8,0,0,0,4.6-4.6L384.9,42.68a16.45,16.45,0,0,1,13.17-10.57,16,16,0,0,1,16.86,10.15l22.84,59.37a8,8,0,0,0,4.6,4.6l59.37,22.84a16,16,0,0,1,0,29.86l-59.37,22.84a8,8,0,0,0-4.6,4.6l-22.84,59.37A16,16,0,0,1,400,256Z'/></svg>
                      </Tooltip>
                    )
                  }
                  {title}

                </h1> */}
                  {helpContent && (
                    <div className='module-header-btns'>
                      <Tooltip
                        title={helpContent}
                        placement='bottom-start'
                        arrow
                        componentsProps={{
                          tooltip: {
                            sx: {
                              display: 'flex',
                              padding:
                                'var(--spacing-md, 8px) var(--spacing-lg, 12px)',
                              flexDirection: 'column',
                              alignItems: 'flex-start',
                              alignSelf: 'stretch',
                              borderRadius: 'var(--radius-md, 8px)',
                              background:
                                'var(--Background-200, var(--bg-colors))',
                              color: 'var(--text-prim25)',
                              maxWidth: '700px',
                              '& .MuiTooltip-arrow': {
                                color:
                                  'var(--Background-200, var(--bg-colors))',
                              },
                            },
                          },
                        }}
                      >
                        <div className='module-header-help'>
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='20'
                            height='20'
                            viewBox='0 0 20 20'
                            fill='none'
                          >
                            <g clipPath='url(#clip0_16034_866)'>
                              <path
                                d='M7.57484 7.50001C7.77076 6.94306 8.15746 6.47343 8.66647 6.17428C9.17547 5.87514 9.77392 5.76579 10.3558 5.8656C10.9377 5.96541 11.4655 6.26794 11.8457 6.71961C12.226 7.17128 12.4341 7.74294 12.4332 8.33334C12.4332 10 9.93317 10.8333 9.93317 10.8333M9.99984 14.1667H10.0082M18.3332 10C18.3332 14.6024 14.6022 18.3333 9.99984 18.3333C5.39746 18.3333 1.6665 14.6024 1.6665 10C1.6665 5.39763 5.39746 1.66667 9.99984 1.66667C14.6022 1.66667 18.3332 5.39763 18.3332 10Z'
                                stroke='#94969C'
                                strokeWidth='1.66667'
                                strokeLinecap='round'
                                strokeLinejoin='round'
                              />
                            </g>
                            <defs>
                              <clipPath id='clip0_16034_866'>
                                <rect width='20' height='20' fill='white' />
                              </clipPath>
                            </defs>
                          </svg>
                          <p>Help</p>
                        </div>
                      </Tooltip>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Grid>
        )}
        <div className='HomeDashboard-container'>{children}</div>
      </Grid>
    </section>
  );
};

export default ModuleHeaderLayout;
